import { ChildrenSiblings } from "../../../SubjectData/BasicWords/Family.js";
import "../../Deck.css";
import FlashcardInterface from "../../Flashcard_Interface.js";
import HeaderNav from "../../../Components/Header/Header_Nav/Header_Nav.js";

export default function ChildrenSiblingsDeck() {

 return (
    <>
      <HeaderNav GoBack_to="/FamilyNav" />
      <FlashcardInterface deckData={ChildrenSiblings} title="Children & Siblings" />
    </>
)}